require( './slider/front.js' );
